import React, { useState } from 'react';
import ReactLoader from 'react-loading';

import { ThemeProps, withTheme } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Container, Content, Label, TravelKindRowContainer, Value } from './styles';
import Checkbox from 'components/Checkbox';

interface AccommodationSelectProps extends ThemeProps<any> {
  title: string;
  height: string;
  top?: string;
  border?: boolean;
  value?: number;
  isLoading: boolean;
  testId?: string;  
  onChange: (value: number) => void;
}

const AccommodationSelect = ({
  title,
  height,
  top,
  border,
  value,
  isLoading,
  testId,
  onChange,
}: AccommodationSelectProps) => {
  const { t } = useStoreTranslation();

  const [accommodationSelected, setAccommodationSelected] = useState<number>(value || 1);
  
  const ACCOMMODATIONS = [
    { label: t('accommodationSelector.single'), value: 1, testId: 'hotel-search-single' },
    { label: t('accommodationSelector.double'), value: 2, testId: 'hotel-search-doble' },
    { label: t('accommodationSelector.triple'), value: 3, testId: 'hotel-search-triple' },
  ];
  
  const renderRoundTripSelect = () => (
    <TravelKindRowContainer>
      {ACCOMMODATIONS.map((flightKind, index) => (
        <TravelKindRowContainer.CheckboxContainer key={index.toString()}>
          <Checkbox
            circle
            checked={flightKind.value === accommodationSelected}
            onChange={() => { setAccommodationSelected(flightKind.value); onChange(flightKind.value) }}
            testId={flightKind.testId}
          />
          <TravelKindRowContainer.label>{flightKind.label}</TravelKindRowContainer.label>
        </TravelKindRowContainer.CheckboxContainer>
      ))}
    </TravelKindRowContainer>
  );
  
  return (
    <>
      <Container height={height} border={border}>
        <Content data-testid={testId}>
          <Label top={top}>{title}</Label>
          <Value active={!!value}>
            {isLoading ? (
              <ReactLoader type="spin" color={ColorPalette.HEX.Gainsboro} width={24} height={24} />
            ) : (
              renderRoundTripSelect()
            )}
          </Value>
        </Content>
        
      </Container>
    </>
  );
};

export default withTheme(AccommodationSelect);
